import axios from 'axios';
import config from '../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from './authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const getGenDocument = createAsyncThunk(
  'get-gen-document',
  async (id) => {
      try{
        const {data} = await axios.get(
          `${base_url}api/api/Document/GetGenDocument/${id}`,
          {headers:authHeader()}
        );
        return data;
      }catch(error){
          if(error.response && error.response.data){
              // return rejectWithValue(error.response.data)
          }else{
              // return rejectWithValue(error.response.data)
          }
      }
  }
);

export const getDocType = createAsyncThunk(
  'get-docType',
  async (id) => {
      try{
        const {data} = await axios.get(
          `${base_url}api/api/Document/GetDocType/${id}`,
          {headers:authHeader()}
        );
        return data;
      }catch(error){
          if(error.response && error.response.data){
              // return rejectWithValue(error.response.data)
          }else{
              // return rejectWithValue(error.response.data)
          }
      }
  }
);

export const getRecentDocumentData = createAsyncThunk(
  'get-recent-document',
  async (payload,{rejectWithValue})=>{
      try{
          const {data} = await axios.post(
              `${base_url}api/api/Document/GetRecentDocumentData`,
              payload,
             { headers:authHeader()}
          );
          return data;
      }catch(error){
          if(error.response && error.response.data){
              return rejectWithValue(error.response.data)
          }else{
              return rejectWithValue(error.response.data)
          }
      }
  }
);

export const getDocStorageData = createAsyncThunk(
  'get-doc-storage',
  async (payload,{rejectWithValue})=>{
      try{
          const {data} = await axios.post(
              `${base_url}api/api/Document/GetDocStorageData`,
              payload,
             { headers:authHeader()}
          );
          return data;
      }catch(error){
          if(error.response && error.response.data){
              return rejectWithValue(error.response.data)
          }else{
              return rejectWithValue(error.response.data)
          }
      }
  }
);
export const saveDocumentType = createAsyncThunk(
    'save-doc-type',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Project/SaveDocumentType`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const getDocumnetType = createAsyncThunk(
    'get-docment-type',
    async (id) => {
        try{
          const {data} = await axios.get(
            `${base_url}api/api/Project/GetDocumentType/${id}`,
            {headers:authHeader()}
          );
          return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
  );

  export const deleteDocumentType=createAsyncThunk(
    'delete-DocumentType',
    async (id) =>{
        try{
            const {data} = await axios.delete(
                `${base_url}api/api/Project/DeleteDocumentType/${id}`,
                {headers:authHeader()}
            );
            return data; 
        }catch(error){
            if(error.response && error.response.data){
                return error.response.data
            }else{
                return error.response.data
            }
        }
    }

);



